<template>
    <div class="page-3d" @touchmove.prevent>
        <div class="bg-3d" @click="closePop"></div>
    </div>
</template>
<script>
export default {
    props: ['scoreInfoData'],
    created() {
        this.POINT('h5_element_imp', {
            page: 'super-成长权益页',
            tgt_event_id: 'h5_ACT_bbsjtc',
            tgt_name: 'h5-ACT-成长权益-版本升级弹窗',
            param: this.scoreInfoData.score,
            param1: this.scoreInfoData.allScore
        });
    },
    methods: {
        closePop() {
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_event_id: 'h5_ACT_bbsjtc_ljty',
                tgt_name: 'h5-ACT-成长权益-版本升级立即体验',
                param: this.scoreInfoData.score,
                param1: this.scoreInfoData.allScore
            });
            this.$emit('OnPopupClose');
        }
    }
};
</script>>

<style lang="less" scoped>
@asserts: '../../../../assets/growth4.0/';
.page-3d {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: 100;
    .bg-3d {
        width: 311px;
        height: 347px;
        background-image: url('@{asserts}upgrade-v4@2x.png');
        background-size: 100% 100%;
    }
}
</style>